module.exports = __webpack_public_path__ + "static/website-bg-032a6bc005b94ec997d112d382645962.mp4";